// ── La dirección del sitio publicado ─────────────────────────────────────────
//
// Un campo que parecía opcional y no lo es. De él dependen, en silencio, tres
// cosas: la medición de PageSpeed, la conexión a Search Console y el enlace
// "Dominio" del panel. Cuando falta, las tres fallan por separado y ninguna dice
// que el problema es el mismo.
//
// Lo que pasó (2026-09-06): el proyecto de Evo Creative tenía `site_url` en
// NULL, así que "SEO del sitio publicado" contestaba "falta la dirección, agregala
// en el paso 2" aunque Eduardo creyera haberla cargado. Y el proyecto de Irea
// tenía `https:/ireafl.com` —una sola barra— guardado sin que nadie lo notara,
// porque no había validación de ningún tipo.
//
// La regla vive acá, en shared, para que el navegador y el servidor apliquen
// EXACTAMENTE la misma: una validación solo en el formulario es una sugerencia,
// y una solo en el servidor llega tarde y con un error feo.
/**
 * Normaliza lo que una persona tipeó, o dice por qué no se puede.
 *
 * Es tolerante en una sola cosa NUESTRA: acepta `ejemplo.com` sin esquema y le
 * pone `https://`. Eso es lo que la gente escribe, y agregarlo no cambia a dónde
 * apunta.
 *
 * El resto de la tolerancia la pone `new URL`, que sigue la especificación: por
 * eso `https:/ejemplo.com` —una barra, como estaba guardado el sitio de Irea—
 * sale como `https://ejemplo.com`. No es una corrección inventada acá, y por eso
 * se puede confiar en ella.
 *
 * Devuelve la URL con el esquema y el host en minúsculas, sin la barra final:
 * es la forma con la que se compara y se concatena en el resto del código.
 */
export function normalizarSiteUrl(crudo) {
    const s = crudo.trim();
    if (s === '')
        return { ok: false, motivo: 'vacia' };
    if (/\s/.test(s))
        return { ok: false, motivo: 'tiene-espacios' };
    // Con esquema, tiene que ser http o https. Un `mailto:` o un `ftp:` acá es un
    // error de campo, no una dirección exótica que haya que soportar.
    //
    // Se mira el NOMBRE del esquema y no `^https?://`: exigir las dos barras
    // rechazaría `https:/ejemplo.com`, que el estándar entiende perfectamente y
    // que es justo lo que había guardado en producción.
    const esquema = /^([a-z][a-z0-9+.-]*):/i.exec(s)?.[1]?.toLowerCase();
    if (esquema && esquema !== 'http' && esquema !== 'https') {
        return { ok: false, motivo: 'esquema-no-http' };
    }
    const conEsquema = esquema !== undefined;
    let u;
    try {
        u = new URL(conEsquema ? s : `https://${s}`);
    }
    catch {
        return { ok: false, motivo: 'sin-dominio' };
    }
    if (u.hostname === '')
        return { ok: false, motivo: 'sin-dominio' };
    // `localhost` no vale: esto es la dirección PÚBLICA, la que Google visita.
    if (!u.hostname.includes('.'))
        return { ok: false, motivo: 'dominio-sin-punto' };
    const camino = u.pathname === '/' ? '' : u.pathname.replace(/\/$/, '');
    return { ok: true, url: `${u.protocol}//${u.hostname.toLowerCase()}${u.port ? `:${u.port}` : ''}${camino}` };
}
/** La versión corta, para cuando solo importa si sirve. */
export function esSiteUrlValida(crudo) {
    return normalizarSiteUrl(crudo).ok;
}
//# sourceMappingURL=site-url.js.map